import { ErrorPage } from 'components/EventStandardContainer/ErrorPage';

export default function Custom404() {
  return <ErrorPage code={404} message="Page Not Found." eventId="/home" />;
}
